import "./BugSummary.css";

import React, { useState, useEffect } from "react";

import "./dropdownCustom.css";

import SelectDropdown from "../../Components/SelectDropDown/SelectDropdown.js";

import loginData from "./userLoginIds.json";

import { getCookie } from "../../services/utils.js";

import { useSelector, useDispatch } from "react-redux";

import ApprovalDialog from "../../Components/Popup/ApprovalDialog";

import {
  setSelectedBugSummary,
  setIsBugSummaryModal,
  setSelectedProjectBugs,
  setBugViewMode,
  setIsBugDashboard,
  setBugSummary,
  setLoading,
} from "../../store/slice/bugSlice.js";

import {
  getRightDropdownBug,
  getFeatureForDemo,
  createBug,
  modifyBug,
  getFeatureByProjId,
  uploadScreenshot,
  getBugSummary,
  deleteBugById,
} from "../../services/homeService.js";

import { useNavigate, useParams } from "react-router-dom";

const BugCreationForm = ({ 
  popupOpen, 
  handleClose, 
  projectId: propProjectId, 
  projectName: propProjectName, 
  clientName: propClientName, 
  subtaskId: propSubtaskId,
  subtaskName: propSubtaskName,
  subtaskSummary: propSubtaskSummary, 
  fromIframe 
}) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { clientId, projectId: urlProjectId } = useParams();
  
  // Use prop projectId if provided, otherwise use URL projectId
  const projectId = propProjectId || urlProjectId;
  
  // Log received props for debugging
  console.log("BugSummary props:", { 
    propProjectId, 
    propProjectName, 
    propClientName, 
    propSubtaskId, 
    propSubtaskName, 
    propSubtaskSummary 
  });

  const { selectedClient } = useSelector((state) => {
    return state.clientDetails;
  });

  const {
    bugSummary,
    selectedBugSummary,
    selectedProject,
    bugViewMode,
    currentBugDetails,
    isBugSummaryModal,
  } = useSelector((state) => {
    return state.bugDetails;
  });

  const [isPatchCalled, setIsPatchCalled] = useState(false);

  const [rightDropdownBugData, setRightDropdownBugData] = useState({
    method: [],
    status: [],
    testingEnvironment: [],
    feature: [],
  });
  const [selectedMethodEnvFeat, setSelectedMethodEnvFeat] = useState({
    status: { value: "1", label: "Open" },
    method: [],
    testingEnv: [],
    feature: [],
  });

  const [comments, setComments] = useState("");

  const [pageTitle, setPageTitle] = useState("");

  const [subSection, setSubSection] = useState("");

  const [description, setDescription] = useState("");
  const nonEditableLines = `URL: ${
    currentBugDetails?.project?.url ?? "-"
  }\nRelease Title: ${currentBugDetails?.project?.userName ?? "-"}\nPublish Date: ${
    currentBugDetails?.project?.password ?? "-"
  }\n`;

  const [stepsToReproduce, setStr] = useState("");

  const [instances, setInstances] = useState("");

  const [actualResult, setActualResult] = useState("");

  const [expectedResult, setExpectedResult] = useState("");

  const [affectedCode, setAffectedCode] = useState("");

  const [suggestedCode, setSuggestedCode] = useState("");

  const [bugid, setBugid] = useState("");
  const [screenShots, setScreenShots] = useState([]);
  const [screenshotUrl, setScreenshotUrl] = useState([]);
  const [deletedScreenshots, setDeletedScreenshots] = useState([])
  const [uploadStatus, setUploadStatus] = useState("");
  const [approvalState, setApprovalState] = useState(false);
  const [openShare, setOpenShare] = useState(false);
  const [newBugid, setNewBugId] = useState(0);
  const [isDeleted, setIsDeleted] = useState(false); // Track if bug is deleted (Invalid)
  const { selectedProjectBugs } = useSelector((state) => {
    return state.bugDetails;
  });

  const projectnonEditableData = `URL: ${
    selectedProject.url ?? "-"
  }\nRelease Title: ${selectedProject.userName ?? "-"}\nPublish Date: ${
    selectedProject.password ?? "-"
  }\n`;

  const filteredBugSummary = bugSummary.filter(summary => {
    if (clientId == 104) {
      return summary.id >= 338 && summary.id <= 428;
    } else if (clientId == 107) {
      return summary.id >= 429;
    } else {
      return true;
    }
  });

  const optionsBugSummary = filteredBugSummary.map((summary) => ({
    ...summary,
    value: summary.id,
    label: summary.name,
  }));
  const [buttonDisable, setButtonDisable] = useState(false);
  
  useEffect(() => {
    const sourceData =
      currentBugDetails && currentBugDetails.length != 0
        ? currentBugDetails
        : selectedBugSummary;

    setActualResult(sourceData.actualResult || "");
    setAffectedCode(sourceData.alteredCode || "");
    setExpectedResult(sourceData.expectedResult || "");
    setInstances(sourceData.instances || "");
    setPageTitle(sourceData.pageTitle || "");
    setSuggestedCode(sourceData.suggestedCode || "");
    setStr(sourceData.stepsToReproduce || "");
    setApprovalState(sourceData.isApproved || false);
    
    // Set isDeleted based on isDeleted property from bug details
    if (bugViewMode && currentBugDetails) {
      setIsDeleted(currentBugDetails.isDeleted === true);
    }
    
    if(sourceData.isApproved){
      setIsPatchCalled(true);
    }
  }, [selectedBugSummary, bugViewMode, currentBugDetails]);

  const handleFileChange = (event) => {
    const files = event.target.files;
    const allowedExtensions = [".png", ".jpeg", ".jpg"];
    const invalidFiles = Array.from(files).filter((file) => {
      const extension = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();
      return !allowedExtensions.includes(extension);
    });
    if (invalidFiles.length > 0) {
      alert("Please select only PNG, JPEG, or JPG files.");
      event.target.value = null;
      return;
    }

    setScreenShots([...screenShots, ...files]);
  };

  const removeScreenshot = (indexToRemove) => {
    const updatedScreenshots = screenshotUrl.filter(
      (_, index) => index !== indexToRemove
    );
    setDeletedScreenshots([...deletedScreenshots, screenshotUrl[indexToRemove]])
    setScreenshotUrl(updatedScreenshots);
  };

  const handleUpload = async () => {
    try {
    } catch (error) {
      setUploadStatus(error.message);
    }
  };
  //DND
  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);
    setScreenShots([...screenShots, ...files]);
  };

  const handleSelectSummary = (selectSummary) => {
    dispatch(setSelectedBugSummary(selectSummary));
  };

  const getRightDropdownBugApi = async () => {
    try {
      console.log("Fetching dropdown data for projectId:", projectId);
      const [bugResp, featureResp, summaryResp] = await Promise.all([
        getRightDropdownBug(),
        getFeatureByProjId(projectId), // Use local projectId instead of selectedProject.id
        getBugSummary(),
      ]);
      dispatch(setBugSummary(summaryResp));
      setRightDropdownBugData(bugResp);

      setRightDropdownBugData((prevState) => ({
        ...prevState,

        feature: featureResp,
      }));
    } catch (error) {
      console.log("error", error);
    }
  };

  const email = getCookie("email");

  useEffect(() => {
    const sourceData =
    currentBugDetails && currentBugDetails.length != 0
      ? currentBugDetails
      : selectedBugSummary;
    
    // Only call the API if we have a valid projectId
    if (projectId) {
      getRightDropdownBugApi();
    }
    dispatch(setSelectedBugSummary([]));
   
  }, [projectId]); // Add projectId as dependency

  const methodDropdownOptions = rightDropdownBugData?.method?.map((method) => ({
    value: method?.id,
    label: method?.value,
  }));

  const testingEnvOptions = rightDropdownBugData?.testingEnvironment?.map(
    (testingEnv) => ({
      value: testingEnv?.id,
      label: testingEnv?.value,
    })
  );

  const featureOptions = rightDropdownBugData?.feature?.map((feat) => ({
    value: feat?.id,
    label: feat?.name,
  }));

  const statusOptions = rightDropdownBugData?.status?.map((status) => ({
    value: status?.id,
    label: status?.value,
  }));

  const handleSelectMethod = (selectMethod) => {
    setSelectedMethodEnvFeat({
      ...selectedMethodEnvFeat,
      method: selectMethod,
    });
  };

  const handleSelectEnv = (selectEnv) => {
    setSelectedMethodEnvFeat({
      ...selectedMethodEnvFeat,
      testingEnv: selectEnv,
    });

    console.log("eee", selectEnv);
  };

  const handleSelectFeature = (selectFeat) => {
    setSelectedMethodEnvFeat({ ...selectedMethodEnvFeat, feature: selectFeat });
  };

  const handleSelectStatus = (e) => {
    const selectedId = e.target.options[e.target.selectedIndex].id;

    setSelectedMethodEnvFeat({
      ...selectedMethodEnvFeat,
      status: { value: selectedId, label: e.target.value },
    });
  };

  const handleBugTypeChange = async (e) => {
    const newValue = e.target.value;
    const newIsDeleted = newValue === "Invalid";
    setIsDeleted(newIsDeleted);

  };

  const testingEnvPayload = selectedMethodEnvFeat?.testingEnv?.map((item) => ({
    id: item.value,
    value: item.label,
  }));

  const createBugApi = async () => {
    try {
      let payload = {
        id: 0, // bug id

        project: {
          id: projectId || selectedProject?.id, // Use local projectId first, fallback to selectedProject.id

          name: propProjectName || selectedProject?.name, // Use prop projectName if available

          clientId: selectedClient?.id,
        },

        feature: {
          id: selectedMethodEnvFeat?.feature?.value,

          name: selectedMethodEnvFeat?.feature?.label,
        },

        pageTitle: pageTitle,

        subSection: subSection,

        description: description,

        comments: comments,
        createdBy: email,

        stepsToReproduce: stepsToReproduce,

        instances: instances,
        actualResult: actualResult,

        expectedResult: expectedResult,

        alteredCode: affectedCode,

        suggestedCode: suggestedCode,

        subtaskId: propSubtaskId, // Add subtaskId to the payload

        bugSummary: {
          id: selectedBugSummary?.id, // bug summary id

          name: selectedBugSummary?.name,

          rationale: selectedBugSummary?.rationale,

          recommendations: selectedBugSummary?.recommendations,

          workingExamples: selectedBugSummary?.workingExamples,

          bugType: selectedBugSummary?.bugType,

          wcagGuidelineReferenceNo:
            selectedBugSummary?.wcagGuidelineReferenceNo,

          wcagPrinciples: selectedBugSummary?.wcagPrinciples,

          wcagVersion: selectedBugSummary?.wcagVersion,

          wcagLevel: selectedBugSummary?.wcagLevel,

          wcagReference: selectedBugSummary?.wcagReference,

          type: selectedBugSummary?.type,

          severity: selectedBugSummary?.severity,

          instances: selectedBugSummary?.instances,

          stepsToReproduce: selectedBugSummary?.stepsToReproduce,

          actualResult: selectedBugSummary?.actualResult,

          expectedResult: selectedBugSummary?.expectedResult,
          suggestedCode: selectedBugSummary?.suggestedCode,

          pageTitle: selectedBugSummary?.pageTitle,
          alteredCode: selectedBugSummary?.alteredCode,
          testingEnvironments: selectedBugSummary?.testingEnvironments,
        },

        status: {
          id: selectedMethodEnvFeat?.status?.value,

          value: selectedMethodEnvFeat?.status?.label,
        },
        method: {
          id: selectedMethodEnvFeat?.method?.value,

          value: selectedMethodEnvFeat?.method?.label,
        },
        testingEnvironments: testingEnvPayload,
      };

      const resp = await createBug(payload);
      if (screenShots != []) {
        await uploadScreenshotApi(resp.id);
      }
    } catch (error) {
      console.log("error");
    }
  };

  const uploadScreenshotApi = async (bugID) => {
    try {
      const resp = await uploadScreenshot(screenShots, bugID);
    } catch (error) {
      console.log(error);
    }
  };

  const modifyBugApi = async (isApprovalState, status) => {
    try {
      let payload = {
        id: 0, // bug id

        project: {
          id: selectedProject?.id, // project id

          name: selectedProject?.name,

          clientId: selectedClient?.id,
        },

        feature: {
          id: selectedMethodEnvFeat?.feature?.value,

          name: selectedMethodEnvFeat?.feature?.label,
        },

        pageTitle: pageTitle,

        subSection: subSection,

        description: description,

        comments: comments,

        createdBy: email,

        stepsToReproduce: stepsToReproduce,

        instances: instances,
        actualResult: actualResult,

        expectedResult: expectedResult,

        alteredCode: affectedCode,

        suggestedCode: suggestedCode,

        bugSummary: {
          id: selectedBugSummary?.id, // bug summary id

          name: selectedBugSummary?.name,

          rationale: selectedBugSummary?.rationale,

          recommendations: selectedBugSummary?.recommendations,

          workingExamples: selectedBugSummary?.workingExamples,

          bugType: selectedBugSummary?.bugType,

          wcagGuidelineReferenceNo:
            selectedBugSummary?.wcagGuidelineReferenceNo,

          wcagPrinciples: selectedBugSummary?.wcagPrinciples,

          wcagVersion: selectedBugSummary?.wcagVersion,

          wcagLevel: selectedBugSummary?.wcagLevel,

          wcagReference: selectedBugSummary?.wcagReference,

          type: selectedBugSummary?.type,

          severity: selectedBugSummary?.severity,

          isApproved: isApprovalState ?? approvalState,
        },

        status: {
          id: status?.value ?? selectedMethodEnvFeat?.status?.value,

          value: status?.label ?? selectedMethodEnvFeat?.status?.label,
        },
        screenshots: deletedScreenshots,
        method: {
          id: selectedMethodEnvFeat?.method?.value,

          value: selectedMethodEnvFeat?.method?.label,
        },
        testingEnvironments: testingEnvPayload,
        isApproved:  isApprovalState ?? approvalState,
        isDeleted: isDeleted,
      };

      console.log("Modifying bug with status:", payload.status);
      console.log("Current user role:", userRole);
      
      const resp = await modifyBug(payload, currentBugDetails.id);
      console.log("Bug successfully modified:", resp);
      return resp;
    } catch (error) {
      console.error("Error modifying bug:", error);
      if (error.response) {
        console.error("Response status:", error.response.status);
        console.error("Response data:", error.response.data);
        
        // Show an alert with the error message
        alert(`Error updating bug: ${error.response?.data?.message || error.message || 'Unknown error'}`);
      }
      throw error;
    }
  };

  

  const userRole = getCookie('role')
  const isContractor = userRole === "CONTRACTOR";


  const handleCreateBug = async () => {
    setButtonDisable(true);
    let selectedProjectId = projectId || selectedProject.id; // Use local projectId first, fallback to selectedProject.id

    await createBugApi();

    dispatch(setIsBugSummaryModal(false));
    dispatch(setSelectedBugSummary([]));
    setButtonDisable(false);

    if (!fromIframe) {
      // Simply navigate back to the previous page in history
      navigate(-1);
    }
    // If fromIframe, do not redirect, just close modal
  };

  const handleModifyBug = async (isApprovalState, status) => {
    try {
      setButtonDisable(true);
      let selectedProjectId = projectId || selectedProject.id; // Use local projectId first, fallback to selectedProject.id
      
      // Check if user has permission to modify the bug
      // if (userRole === "CONTRACTOR" && !isApprovalState) {
      //   // If contractor is trying to modify status other than through approval process
      //   alert("You don't have permission to modify this bug's status.");
      //   setButtonDisable(false);
      //   return;
      // }
      
      await modifyBugApi(isApprovalState, status);
      setIsPatchCalled(true);

      if (screenShots.length > 0) {
        await uploadScreenshotApi(bugid);
      }
      dispatch(setIsBugSummaryModal(false));
      dispatch(setBugViewMode(false));
      dispatch(setSelectedBugSummary([]));

      
      // Simply navigate back to the previous page in history
      if (!fromIframe) {
        navigate(-1);
      }
    } catch (error) {
      console.error("Failed to modify bug:", error);
      // Error is already handled in modifyBugApi
    } finally {
      setButtonDisable(false);
    }
  };

  const handleCloseBtn = () => {
    dispatch(setBugViewMode(false));
    dispatch(setIsBugSummaryModal(false));

    // When opened from iframe, don't navigate away, just close the modal
    if (fromIframe) {
      console.log("Closing bug summary modal from iframe without navigation");
      dispatch(setSelectedBugSummary([]));
      handleClose();
      return;
    }

    // Navigate back to the previous page in history
    navigate(-1);
    
    dispatch(setSelectedBugSummary([]));
    handleClose();
  };

  useEffect(() => {
    if (bugViewMode) {
      const testingEnvData = currentBugDetails?.testingEnvironments?.map(
        (item) => ({
          value: item.id,
          label: item.value,
        })
      );
      setBugid(currentBugDetails?.id);

      setComments(currentBugDetails.comments);

      setPageTitle(currentBugDetails.pageTitle);

      setSubSection(currentBugDetails.subSection);

      setDescription(currentBugDetails.description);

      setStr(currentBugDetails.stepsToReproduce);

      setInstances(currentBugDetails.instances);

      setActualResult(currentBugDetails.actualResult);

      setExpectedResult(currentBugDetails.expectedResult);

      setAffectedCode(currentBugDetails.alteredCode);

      setSuggestedCode(currentBugDetails.suggestedCode);

      setSelectedMethodEnvFeat({
        ...selectedMethodEnvFeat,

        status: {
          value: currentBugDetails?.status?.id,

          label: currentBugDetails?.status?.value,
        },

        method: {
          value: currentBugDetails.method?.id,

          label: currentBugDetails?.method?.value,
        },

        testingEnv: testingEnvData,

        feature: {
          value: currentBugDetails?.feature?.id,

          label: currentBugDetails?.feature?.name,
        },
      });
      setScreenshotUrl(currentBugDetails?.screenshots);
      dispatch(
        setSelectedBugSummary({
          value: currentBugDetails?.bugSummary?.id,

          label: currentBugDetails?.bugSummary?.name,

          rationale: currentBugDetails?.bugSummary?.rationale,

          recommendations: currentBugDetails?.bugSummary?.recommendations,

          workingExamples: currentBugDetails?.bugSummary?.workingExamples,

          bugType: currentBugDetails?.bugSummary?.bugType,

          wcagGuidelineReferenceNo:
            currentBugDetails?.bugSummary?.wcagGuidelineReferenceNo,

          wcagPrinciples: currentBugDetails?.bugSummary?.wcagPrinciples,

          wcagVersion: currentBugDetails?.bugSummary?.wcagVersion,

          wcagLevel: currentBugDetails?.bugSummary?.wcagLevel,

          wcagReference: currentBugDetails?.bugSummary?.wcagReference,

          type: currentBugDetails?.bugSummary?.type,

          severity: currentBugDetails?.bugSummary?.severity,
        })
      );
    }
  }, [bugViewMode, currentBugDetails, isBugSummaryModal]);
  const isEmailExists = loginData.login.includes(email);

  const approval = async () => {
    if (isEmailExists) {
      setSelectedMethodEnvFeat({
        ...selectedMethodEnvFeat,
        status: { value: '5', label: 'Approved' },
      });
      setApprovalState(true);
      await handleModifyBug(true, { value: '5', label: 'Approved' } )
      setOpenShare(true);
    } else {
      setApprovalState(false);

      setOpenShare(true);
    }
  };
  
  const handleCloseShare = () => {
    setOpenShare(false);
  };

  const setTestingEnvValue = () => {
    return selectedMethodEnvFeat.testingEnv;
  };

const preventCopy = (event) => {
    event.preventDefault();
  };


const hideScreenshots = true;
const hideEpicTheme = true;

  return (
    <div> 
       <div
      className="bug-summary"
      style={{
        userSelect: userRole === "CONTRACTOR" ? 'none' : 'auto',
        MozUserSelect: userRole === "CONTRACTOR" ? 'none' : 'auto',
        WebkitUserSelect: userRole === "CONTRACTOR" ? 'none' : 'auto',
      }}
      onCopy={userRole === "CONTRACTOR" ? preventCopy : null}
      open={popupOpen}
      onContextMenu={(e) => userRole === "CONTRACTOR" && e.preventDefault()}
    >

        {/* <Dialog
        maxWidth="1363px"
        maxHeight="473px"
        className="bug-summary"
        open={popupOpen}
      > */}

        <div className="content-dialog2">
          {/* <DialogContent className="content-dialog2"> */}

          <div>
            {/* <div style={{ height: "432px" }}> */}

            <div className="dropDownPanel">
            {/* <div style={{width: '100px'}}>
              <div className="title font-poppins">Bug ID</div>
              <div>{bugid}</div>
            </div> */}
            

          
            <div style={{width: '100%'}}>
              <label>Bug Summary</label>

              <SelectDropdown
                isMulti={false}
                width={"inherit"}
                options={optionsBugSummary}
                onChange={handleSelectSummary}
                value={selectedBugSummary}
                isSearchable={true}
                isDisabled={bugViewMode}
                classDrop={"customDrop"}
                classSelect={"customSelect"}
              />
            </div>
            </div>

            <div className="pane-wrapper">
              <div className="left-pane" style={{ gap: "20px" }}>
                <div>
                  <div className="leftPaneColor">
                    <div className="title">Rationale</div>
                    <div>{selectedBugSummary?.rationale ?? "N/A"}</div>
                  </div>                

                  <div className="leftPaneColor">
                    <div className="title">Recommendations</div>
                    <div>{selectedBugSummary?.recommendations ?? "N/A"}</div>
                  </div>
                </div>
              
                <div>
                  <div className="title">
                    <label style={{ fontFamily: "Raleway" }}>Comments</label>
                  </div>

                  <div>
                    <textarea
                      style={{ height: "80px" }}
                      className="custom-area"
                      placeholder="Type here"
                      value={comments}
                      onChange={(e) => setComments(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="mid-pane">
                <div
                  className="2-column"
                  style={{
                    display: "flex",

                    flexDirection: "row",

                    alignItems: "flex-start",
                    justifyContent: "space-between",
                  }}
                >
                  {/* <div style={{ paddingRight: "16px" }}> */}
                  <div style={{ width: "48%" }}>
                    <label className="title font-raleway">Feature</label>

                    <SelectDropdown
                      options={featureOptions}
                      value={selectedMethodEnvFeat.feature}
                      isSearchable={true}
                      onChange={handleSelectFeature}
                      isMulti={false}
                      // width={"18vw"}

                      classSelect={"customSelect2"}
                    />
                  </div>

                  {/* <div style={{ width: "21.7vw" }}> */}

                  <div style={{ width: "48%" }}>
                    <div className="title font-raleway">Count</div>

                    <div>
                      <textarea
                        className="custom-area"
                        style={{ height: "40px" }}
                        value={pageTitle}
                        onChange={(e) => setPageTitle(e.target.value)}
                        placeholder="Type here"
                      />
                    </div>
                  </div>
                </div>

                <div className="middlePaneWrapper" style={{ gap: 0 }}>
                  {clientId!=107 && (
                               
                  <div>
                    <div className="title font-raleway">Description</div>

                    <div>
                      <textarea
                        style={{ minHeight: "80px", height: "150px" }}
                        className="custom-area"
                        value={
                          bugViewMode
                            ?  description
                            : projectnonEditableData + description
                        }
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Type here"
                        disabled={true}
                      />
                    </div>
                  </div>
                  )}


                  <div
                    style={{
                      borderTop: "1px solid #8891AA",
                      padding: "10px 0 ",
                    }}
                  >
                    <div className="title font-raleway">Steps to reproduce</div>

                    <textarea
                      style={{ minHeight: "80px", height: "450px" }}
                      className="custom-area"
                      draggable
                      value={stepsToReproduce}
                      onChange={(e) => setStr(e.target.value)}
                      placeholder="Type here"
                    />
                  </div>
                  
                  
                  <div
                    style={{
                      borderTop: "1px solid #8891AA",
                      padding: "10px 0 ",
                    }}
                  >
                    <div className="title font-raleway">Instances</div>

                    <textarea
                      style={{ minHeight: "80px" }}
                      className="custom-area"
                      value={instances}
                      onChange={(e) => {
                        console.log("Intance e.target changed");
                        setInstances(e.target.value);
                      }}
                      placeholder="Type here"
                    />
                  </div>

                {!hideScreenshots && (
                  <div
                    style={{
                      borderTop: "1px solid #8891AA",
                      padding: "10px 0 ",
                    }}
                  >
                    <div className="title font-raleway">Screenshot</div>
                    <div className="custom-area-div">
                      <label
                        htmlFor="fileInput"
                        className="chooseBtn"
                        style={{
                          cursor: "pointer",
                          padding: "10px 15px",
                          backgroundColor: "#4404bf",
                          color: "#fff",
                          borderRadius: "5px",
                          border: "none",
                          fontSize: "14px",
                          marginBottom: "15px",
                          display: "inline-block",
                        }}
                      >
                        Choose files
                      </label>

                      <input
                        type="file"
                        id="fileInput"
                        onChange={handleFileChange}
                        multiple
                        accept=".png, .jpeg, .jpg"
                        style={{
                          display: "none",
                        }}
                      />

                      <div
                        className="screenshot-wrapper"
                        style={{ marginTop: "10px" }}
                      >
                        {screenshotUrl?.map((url, index) => (
                          <div
                            className="screenshot-block"
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "15px",
                              padding: "10px",
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                              position: "relative",
                            }}
                          >
                            <img
                              className="screenshot-image"
                              src={url.url}
                              style={{
                                width: "120px",
                                height: "80px",
                                borderRadius: "5px",
                                marginRight: "15px",
                                objectFit: "cover",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                              }}
                              alt={`Screenshot ${index + 1}`}
                              draggable={false}
                            />

                            <a
                              target="_blank"
                              href={url.url}
                              className="screenshot-title"
                              title={url.filename}
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#333",
                                textDecoration: "none",
                              }}
                            >
                              Screenshot {index + 1}
                            </a>

                            <button
                              onClick={() => removeScreenshot(index)}
                              style={{
                                backgroundColor: "#FF5A5F",
                                border: "none",
                                color: "#fff",
                                fontSize: "16px",
                                cursor: "pointer",
                                marginLeft: "auto",
                                padding: "5px 10px",
                                borderRadius: "50%",
                                position: "absolute",
                                right: "10px",
                                top: "10px",
                              }}
                            >
                              &times;
                            </button>
                          </div>
                        ))}
                      </div>

                      {/* Uploaded File Names */}
                      <div style={{ position: "relative", marginTop: "10px" }}>
                        {screenShots?.map((file, index) => (
                          <p
                            key={index}
                            style={{
                              marginBottom: "10px",
                              fontSize: "14px",
                              color: "#555",
                            }}
                          >
                            {file.name}
                            <button
                              onClick={() => removeScreenshot(index)}
                              style={{
                                backgroundColor: "#FF5A5F",
                                border: "none",
                                color: "#fff",
                                fontSize: "16px",
                                cursor: "pointer",
                                marginLeft: "10px",
                                padding: "5px 10px",
                                borderRadius: "50%",
                              }}
                            >
                              &times;
                            </button>
                          </p>
                        ))}
                      </div>

                      <p
                        style={{
                          marginTop: "15px",
                          fontSize: "14px",
                          color: "#555",
                        }}
                      >
                        {uploadStatus}
                      </p>
                    </div>
                  </div>
                )}

                  <div
                    style={{
                      display: "flex",

                      flexDirection: "column",

                      justifyContent: "space-between",

                      borderTop: "1px solid #8891AA",

                      padding: "10px 0 ",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <div className="title font-raleway">Actual Result</div>

                      <textarea
                        style={{ minHeight: "80px", height: "150px" }}
                        className="custom-area"
                        value={actualResult}
                        onChange={(e) => setActualResult(e.target.value)}
                        placeholder="Type here"
                      />
                    </div>

                    <div style={{ width: "100%" }}>
                      <div className="title font-raleway">Correction</div>

                      <textarea
                        style={{ minHeight: "80px", height: "150px" }}
                        className="custom-area"
                        value={expectedResult}
                        onChange={(e) => setExpectedResult(e.target.value)}
                        placeholder="Type here"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",

                      flexDirection: "row",

                      justifyContent: "space-between",

                      borderTop: "1px solid #8891AA",

                      padding: "10px 0 ",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <div className="title font-raleway">Screenshot link</div>

                      <textarea
                        style={{ minHeight: "80px", height: "150px" }}
                        className="custom-area"
                        value={affectedCode}
                        onChange={(e) => setAffectedCode(e.target.value)}
                        placeholder="Type here"
                      />
                    </div>

                  {!hideEpicTheme && (
                    <div style={{ width: "45%" }}>
                      <div className="title font-raleway">Epic/Theme</div>
                      <textarea
                        style={{ minHeight: "80px", height: "150px" }}
                        className="custom-area"
                        value={suggestedCode}
                        onChange={(e) => setSuggestedCode(e.target.value)}
                        placeholder="Type here"
                      />
                    </div>
                  )}
                  </div>

                  {/* <button
                    className="approvalButton"
                    disabled={
                      !bugViewMode ||
                      approvalState ||
                      selectedMethodEnvFeat.status.label == "Closed" 
                      || !isEmailExists
                    }
                    onClick={approval}
                  >
                    {approvalState ? "Approved" : "Approval"}
                  </button> */}
                  <div>
                    {/* {openShare && (
                      <ApprovalDialog
                        open={openShare}
                        handleClose={handleCloseShare}
                        title={
                          approvalState
                            ? "Approved!!"
                            : "User is not authorized for this transaction"
                        }
                      />
                    )} */}
                  </div>
                </div>
              </div>

              <div className="right-pane">
                <div
                  className={bugViewMode ? "pd-16px" : "pd-16px disableStatus"}
                >
                  <div className="title font-raleway">Status</div>

                  <div>
                    <select
                      className="status-drop"
                      value={selectedMethodEnvFeat.status.label}
                      disabled={isContractor || selectedMethodEnvFeat.status.label == "Closed"}
                      onChange={(e) => {
                        handleSelectStatus(e);
                      }}
                    >
                      {statusOptions.map((status) => {
                        if (status.label !== "In Progress") {
                          let isDisabled = false;

                          // Hide "Approved" if approvalState is false
                          if (!approvalState && status.label === "Approved") {
                            return null;
                          }

                          // Disable "Open" and "Resolved" when approvalState is true
                          if (
                            approvalState &&
                            (status.label === "Open" ||
                              status.label === "Resolved"|| status.label === "Closed")
                          ) {
                            isDisabled = true;
                          }

                          return (
                            <option
                              id={status.value}
                              value={status.label}
                              disabled={isDisabled}
                              style={isDisabled ? { backgroundColor: "grey" } : {}}
                            >
                              {status.label}
                            </option>
                          );
                        } else {
                          return null; // Hide "In Progress"
                        }
                      })}
                    </select>
                  </div>
                </div>
                
                <div
                  className={bugViewMode ? "pd-16px" : "pd-16px disableStatus"}
                >
                  <div className="title font-raleway">Bug Type</div>

                  <div>
                    <select
                      className="status-drop"
                      value={isDeleted ? "Invalid" : "Valid"}
                      disabled={!bugViewMode || isContractor}
                      onChange={handleBugTypeChange}
                    >
                      <option value="Valid">Valid</option>
                      <option value="Invalid">Invalid</option>
                    </select>
                  </div>
                </div>
                
                <div className="pd-16px">
                  <div className="title">
                    <label className="font-raleway">Testing Environment</label>
                  </div>

                  <SelectDropdown
                    value={selectedMethodEnvFeat.testingEnv}
                    options={testingEnvOptions}
                    onChange={handleSelectEnv}
                    isSearchable={true}
                    classSelect={"customSelect2"}
                    isMulti={true}
                  />
                </div>

                <div
                  style={{
                    backgroundColor: "#EFF6FF",

                    padding: "15px",

                    borderRadius: "4px",

                    display: "grid",

                    gap: "15px",
                  }}
                >
                  <div>
                    <div className="title font-raleway">Bug Type</div>

                    <div className="under-title font-raleway">
                      {selectedBugSummary?.bugType ?? "N/A"}
                    </div>
                  </div>

                  <div>
                    <div className="title font-raleway">
                      WCAG Guideline Reference No
                    </div>

                    <div className="under-title font-raleway">
                      {selectedBugSummary?.wcagGuidelineReferenceNo ?? "N/A"}
                    </div>
                  </div>

                  <div>
                    <div className="title font-raleway">WCAG Principles</div>

                    <div className="under-title font-raleway">
                      {selectedBugSummary?.wcagPrinciples ?? "N/A"}
                    </div>
                  </div>

                  <div>
                    <div className="title font-raleway">WCAG Version</div>

                    <div className="under-title font-raleway">
                      {selectedBugSummary?.wcagVersion ?? "N/A"}
                    </div>
                  </div>

                  <div>
                    <div className="title font-raleway">WCAG Level</div>

                    <div className="under-title font-raleway">
                      {selectedBugSummary?.wcagLevel ?? "N/A"}
                    </div>
                  </div>
                  <div>
                    <div className="title font-raleway">Label</div>

                    <div className="under-title font-raleway">
                      {selectedBugSummary?.type ?? "N/A"}
                    </div>
                  </div>

                  <div>
                    <div className="title font-raleway">Severity</div>

                    <div className="under-title font-raleway">
                      {selectedBugSummary?.severity ?? "N/A"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            margin: "20px 25px 10px 0", /* Increased top margin, added bottom margin */
            padding: "0 15px", /* Added horizontal padding */
          }}
        >
          <button className="cancelBtn" onClick={handleCloseBtn}>
            Cancel
          </button>

          <button
            disabled={
              !(
                selectedMethodEnvFeat?.testingEnv?.length &&
                selectedMethodEnvFeat?.feature?.value &&
                selectedBugSummary.length != 0 &&
                pageTitle &&
                instances &&
                affectedCode                
              ) || buttonDisable || (isPatchCalled && approvalState) && !isEmailExists
            }
            className="createBtn"
            onClick={() => bugViewMode ? handleModifyBug() : handleCreateBug()}
          >
            <span style={{ display: bugViewMode ? "none" : "" }}>Create</span>

            <span style={{ display: bugViewMode ? "" : "none" }}>Modify</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BugCreationForm;
